module.exports = __webpack_public_path__ + "img/promo_logo03.32d3b767.png";